module.exports = __webpack_public_path__ + "img/features-2-first_section.e672907d.png";